import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom"; // ⬅️ Added useNavigate
import {
  FiHome,
  FiUsers,
  FiUser,
  FiBriefcase,
  FiChevronRight,
  FiChevronDown,
  FiMenu,
  FiLogOut,
} from "react-icons/fi";
import { FaBuilding } from 'react-icons/fa';
import ConfirmActionModal from "../Shared/ConfirmActionModal";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openSections, setOpenSections] = useState({
    "Super Admin": true,
    "Company Admin": true,
    Viewer: true,
  });
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate(); // ⬅️ Hook for redirection

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    // ✅ Perform logout logic
    localStorage.removeItem("token"); // or sessionStorage, depending on use
    // You can also clear more data if needed, like user info
    setShowLogoutModal(false);
    navigate("/login"); // ⬅️ Redirect to login page
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const sections = [
 
    {
      title: "Viewer",
      items: [{ label: "Companies List", to: "/viewer/companies-list", icon: <FiUsers /> }],
    },
  ];

  return (
    <>
      <div
        className={`h-screen bg-white text-gray-600 shadow-lg flex flex-col justify-between transition-all duration-300 ${
          isCollapsed ? "w-20" : "w-64"
        }`}
      >
        {/* Top: Toggle + Title */}
        <div>
          <div className="flex items-center justify-between px-4 py-5 border-b border-gray-100">
            {!isCollapsed && (
              <h2 className="text-xl font-extrabold tracking-wide text-gray-600">
                Viewer
              </h2>
            )}
            <button
              className={`${isCollapsed ? "ml-2" : "ml-0"}`}
              onClick={toggleCollapse}
            >
              <FiMenu className="text-2xl text-gray-600 hover:text-black-300" />
            </button>
          </div>

          {/* Navigation Sections */}
          <nav className="mt-4">
            {sections.map((section) => (
              <div key={section.title}>
                <button
                  onClick={() => toggleSection(section.title)}
                  className="w-full flex items-center justify-between px-4 py-2 text-gray-600  rounded-lg transition-all"
                >
                  {!isCollapsed && (
                    <span className="text-sm font-bold">{section.title}</span>
                  )}
                  {openSections[section.title] ? (
                    <FiChevronDown className="text-sm" />
                  ) : (
                    <FiChevronRight className="text-sm" />
                  )}
                </button>

                <div>
                  {openSections[section.title] &&
                    section.items.map((link) => (
                      <NavLink
                        key={link.to}
                        to={link.to}
                        className={({ isActive }) =>
                          `flex items-center gap-4 px-4 py-3 ml-2 mt-2 rounded-md font-medium transition-all ${
                            isActive
                              ? "bg-gray-100 text-gray-600 border-l-4 border-gray-600"
                              : "hover:bg-black-400 text-gray-600"
                          }`
                        }
                      >
                        <span className="text-xl">{link.icon}</span>
                        {!isCollapsed && <span>{link.label}</span>}
                      </NavLink>
                    ))}
                </div>
              </div>
            ))}
          </nav>
        </div>

        {/* Bottom: Logout */}
        <div className="px-4 py-5 border-t border-gray-100">
          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-4 text-red-400 hover:text-red-600 transition-all"
          >
            <FiLogOut className="text-xl" />
            {!isCollapsed && <span className="font-semibold">Logout</span>}
          </button>
        </div>
      </div>

      {/* ✅ Logout Modal */}
      <ConfirmActionModal
  isOpen={showLogoutModal}
  onCancel={handleLogoutCancel}
  onConfirm={handleLogoutConfirm}
  title="Confirm Logout"
  message="Are you sure you want to logout?"
  confirmText="Logout"
  confirmColor="red"
/>
    </>
  );
};

export default Sidebar;
